import { XCircle } from "lucide-react";
import Reveal from "@/components/site/Reveal";
import SectionLabel from "@/components/site/SectionLabel";

const STRUGGLES = [
    "Overthinking every conversation, text, and approach",
    "Chasing women who clearly aren't choosing you",
    "Reading 100 articles, watching 1000 videos, applying none of it",
    "Winning in your career — losing in your dating life",
    "Killing attraction with neediness, hesitation, or low self-worth",
    "No structure, no plan, no accountability — just hoping things change",
];

export default function Problem() {
    return (
        <section
            id="problem"
            data-testid="problem-section"
            className="relative bg-[#020617] py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
                    <div className="md:col-span-5">
                        <Reveal>
                            <SectionLabel testId="problem-label">
                                The Problem
                            </SectionLabel>
                            <h2 className="mt-6 font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                                Most men aren’t{" "}
                                <span className="italic font-light">
                                    unattractive
                                </span>
                                .
                                <br />
                                They’re{" "}
                                <span className="text-[#D4AF37]">stuck</span>.
                            </h2>
                            <p className="mt-6 text-white/70 leading-relaxed max-w-md">
                                You don’t have a “looks” problem or a “luck”
                                problem. You have a clarity, confidence, and
                                consistency problem — and no one ever gave you
                                the structured plan to fix it.
                            </p>
                        </Reveal>
                    </div>

                    <div className="md:col-span-7">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#142142] border border-[#142142]">
                            {STRUGGLES.map((s, i) => (
                                <Reveal key={i} delay={i * 0.05}>
                                    <div className="bg-[#020617] p-6 h-full flex items-start gap-4 group hover:bg-[#060c1e] transition-colors">
                                        <XCircle
                                            size={20}
                                            className="text-[#8B0000] mt-0.5 flex-shrink-0 group-hover:text-[#991B1B] transition-colors"
                                        />
                                        <p className="text-white/85 leading-relaxed text-sm">
                                            {s}
                                        </p>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
